import { useContext } from 'react';
import PropTypes from 'prop-types';
import i18nContext from 'components/i18n-context';
import Button from 'uikit/Button/Button';
import './OperatorsTableRowContent.scss';

const OPERATOR_ROLES = {
  SUPER_ADMIN: 'SUPER_ADMIN',
  ADMIN: 'ADMIN',
  SALES: 'SALES',
  CUSTOMER_CARE: 'CUSTOMER_CARE',
  TECHNICAL_SUPPORT: 'TECHNICAL_SUPPORT',
  FINANCE: 'FINANCE',
  AML: 'AML'
};

export const OperatorsTableRowContent = ({ operatorData, handleUpdateOperator, isLoading }) => {
  const i18n = useContext(i18nContext);

  // Extract role from authorities or use the role field if it exists
  const getOperatorRole = () => {
    // If the operator has a role field (new structure)
    if (operatorData.role) {
      return operatorData.role;
    }

    // Otherwise, check authorities for FULL_ACCESS (old structure)
    if (operatorData.authorities?.includes('FULL_ACCESS')) {
      return 'ADMIN'; // Default to ADMIN for operators with FULL_ACCESS
    }

    return 'UNKNOWN';
  };

  const getStatusBadgeClass = () => {
    if (operatorData.enabled === false) {
      return 'operator-status-badge operator-status-disabled';
    }
    return 'operator-status-badge operator-status-active';
  };

  const getStatusText = () => {
    if (operatorData.enabled === false) {
      return i18n.getMessage('operators.status.disabled');
    }
    return i18n.getMessage('operators.status.enabled');
  };

  const getRoleBadgeClass = (role) => {
    const roleClass = role.toLowerCase().replace('_', '-');
    return `operator-role-badge operator-role-${roleClass}`;
  };

  const role = getOperatorRole();

  return (
    <tr className='operators-table-row'>
      <td>{operatorData.id}</td>
      <td>{operatorData.login}</td>
      <td>{operatorData.name || '-'}</td>
      <td>{operatorData.email || '-'}</td>
      <td>
        <span className={getRoleBadgeClass(role)}>{i18n.getMessage(`operators.role.${role}`)}</span>
      </td>
      <td>
        <span className={getStatusBadgeClass()}>{getStatusText()}</span>
      </td>
      <td>
        <Button size='small' type='secondary' onClick={() => handleUpdateOperator(operatorData)} isDisabled={isLoading}>
          {i18n.getMessage('operators.button.update')}
        </Button>
      </td>
    </tr>
  );
};

OperatorsTableRowContent.propTypes = {
  operatorData: PropTypes.shape({
    id: PropTypes.number,
    login: PropTypes.string,
    name: PropTypes.string,
    email: PropTypes.string,
    role: PropTypes.string,
    authorities: PropTypes.arrayOf(PropTypes.string),
    enabled: PropTypes.bool
  }).isRequired,
  handleUpdateOperator: PropTypes.func.isRequired,
  isLoading: PropTypes.bool
};
